export interface Avatar {
  consumerId: string;
  avatarId: string;
  avatarFileName: string;
}

export type MapAvatar = Record<string, React.ReactNode>;

/* This is not currently being used. We are using ConsumerSharedUiData.
 Keeping for future use */
export interface ConsumerMobileUiData {
  isWaitingRoomVideoComplete?: boolean;
}

/* This is not currently being used. We are using ConsumerSharedUiData.
 Keeping for future use */
export interface ConsumerWebUiData {
  hasAcceptedConnectCareTermsAndConditions?: boolean;
}

export interface ConsumerSharedUiData {
  isWaitingRoomVideoComplete?: boolean;
  hasAcceptedConnectCareTermsAndConditions?: boolean;
  isHealthToolSurveyCompleted?: boolean;
  avatars?: Avatar[];
  preferredLanguage?: 'en' | 'es';
}

export interface ConsumerPreferences {
  consumerId: string;
  uiData: {
    webUiData?: ConsumerWebUiData;
    mobileUiData?: ConsumerMobileUiData;
    sharedUiData?: ConsumerSharedUiData;
  };
}

export enum LANGUAGE {
  ENGLISH = 'en',
  SPANISH = 'es'
}
